/**
 * Network utility functions to avoid circular dependencies
 */

/**
 * Simple function to check if the browser is offline
 * This is a basic check that doesn't rely on the OfflineService
 */
export function isBrowserOffline(): boolean {
  return !navigator.onLine;
}

/**
 * Register event listeners for online/offline events
 * @param onOnline Callback for when the browser goes online
 * @param onOffline Callback for when the browser goes offline
 * @returns A cleanup function to remove the event listeners
 */
export function registerNetworkListeners(
  onOnline: () => void,
  onOffline: () => void
): () => void {
  window.addEventListener('online', onOnline);
  window.addEventListener('offline', onOffline);

  return () => {
    window.removeEventListener('online', onOnline);
    window.removeEventListener('offline', onOffline);
  };
}

// Export as default object as well
export default {
  isBrowserOffline,
  registerNetworkListeners
}; 